"use client";

import type { TextColor } from "@homeinstead/schemas";
import type { PortableTextBlock } from "next-sanity";
import type { ReactNode } from "react";

import { track } from "@homeinstead/analytics";
import { EventName, scrollToTop } from "@homeinstead/shared";
import { Button } from "@homeinstead/ui/components/Button";
import { RichText } from "@homeinstead/ui/components/RichText";
import { useState } from "react";

type InquiryIntroSectionProps = {
  children: ReactNode;
  ctaElementName: string;
  ctaLabel: string;
  initialStep?: PortableTextBlock[];
  textColor?: TextColor;
};

function InquiryIntroSection({
  children,
  ctaElementName,
  ctaLabel,
  initialStep,
  textColor,
}: InquiryIntroSectionProps) {
  const [hasStarted, setHasStarted] = useState(false);

  const handleLinkClick = (href: string) => {
    track(EventName.TRACKED_CLICK, {
      element_name: "rich_text_link",
      target_url: href,
    });
  };

  const handleStart = () => {
    track(EventName.TRACKED_CLICK, {
      element_name: ctaElementName,
    });
    setHasStarted(true);
    scrollToTop();
  };

  if (!hasStarted) {
    return (
      <div>
        <RichText
          onLinkClick={handleLinkClick}
          textColor={textColor}
          value={initialStep ?? []}
        />
        <div className="mt-6">
          <Button
            className="h-12 rounded-full px-8"
            onClick={handleStart}
            type="button"
            variant="friendly"
          >
            {ctaLabel}
          </Button>
        </div>
      </div>
    );
  }

  return children;
}

export { InquiryIntroSection };
